import { render, staticRenderFns } from "./etapa_4.vue?vue&type=template&id=5cfd2ea2&scoped=true&"
import script from "./etapa_4.vue?vue&type=script&lang=js&"
export * from "./etapa_4.vue?vue&type=script&lang=js&"
import style0 from "./etapa_4.vue?vue&type=style&index=0&id=5cfd2ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfd2ea2",
  null
  
)

export default component.exports